import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import AudioTest from "./pages/AudioTest";
import Review from "./pages/Review";
import Success from "./pages/Success";
import Settings from "./pages/Settings";
import SignInPage from "./pages/SignIn";
import SignUpPage from "./pages/SignUp";
import Invoices from "./pages/Invoices";
import InvoiceDetail from "./pages/InvoiceDetail";
import Privacy from "./pages/Privacy";
import Faq from "./pages/Faq";
import TradePage from "./pages/TradePage";
import { TRADES } from "./data/trades";
import RequireAuth from "./components/RequireAuth";
import ProfileMigrator from "./components/ProfileMigrator";
import { PageMeta } from "./hooks/usePageMeta";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        {/* Per-route <title>/<meta>/<link> — hoisted to <head> by React 19. */}
        <PageMeta />
        <ProfileMigrator />
        <Routes>
          {/* Public — anonymous record/review/PDF + Settings (sessionStorage) */}
          <Route path="/" element={<Home />} />
          <Route path="/audio-test" element={<AudioTest />} />
          <Route path="/review/:sessionId" element={<Review />} />
          <Route path="/success/:sessionId" element={<Success />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/faq" element={<Faq />} />
          {TRADES.map((t) => (
            <Route key={t.slug} path={"/" + t.slug} element={<TradePage slug={t.slug} />} />
          ))}

          {/* Auth */}
          <Route path="/sign-in/*" element={<SignInPage />} />
          <Route path="/sign-up/*" element={<SignUpPage />} />

          {/* Auth-required — invoice history only makes sense signed in */}
          <Route
            path="/invoices"
            element={
              <RequireAuth>
                <Invoices />
              </RequireAuth>
            }
          />
          <Route
            path="/invoices/:invoiceId"
            element={
              <RequireAuth>
                <InvoiceDetail />
              </RequireAuth>
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
